import React from "react";
import { Stack, Typography, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

// ----------------------------------------------------------------------
const AnimationStyle = styled(Stack)(() => ({
  "@keyframes spin": {
    "100%": {
      transform: "rotate(360deg)",
    },
  },
}));

// ----------------------------------------------------------------------

export default function AboutContent() {
  return (
    <Stack direction="row" sx={{ borderBottom: "1px solid #ffffff80" }}>
      <Stack
        sx={{
          borderRight: "1px solid #ffffff80",
          p: "2% 2% 2.5% 2%",
          width: { xs: "100%", md: "30%" },
          m: "auto",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xs: "25px",
              sm: "32px",
              md: "25px",
              lg: "35px",
              xl: "55px",
            },
            fontWeight: 700,
            lineHeight: 1.1,
          }}
        >
          THE FIRST DIGITAL CREATIVE NEIGHBOR HOOD.
        </Typography>
      </Stack>
      <Stack
        sx={{
          borderRight: "1px solid #ffffff80",
          width: { xs: "100%", md: "70%" },
          position: "relative",
        }}
      >
        <Box
          component="img"
          alt="IB-4"
          src="/assets/IB-4-1.png"
          sx={{ width: "100%", height: "auto" }}
        />
        <AnimationStyle>
          <Box
            component="img"
            alt="text"
            src="/assets/text.png"
            sx={{
              width: { xs: "50px", sm: "70px", lg: "100px", xl: "130px" },
              height: { xs: "50px", sm: "70px", lg: "100px", xl: "130px" },
              position: "absolute",
              // left: { xs: "", md: "35px", xl: "60px" },
              right: { xs: "-25px", sm: "60px", md: "105px" },
              top: {
                xs: "-27px",
                sm: "-40px",
                md: "-40px",
                lg: "-50px",
                xl: "-70px",
              },
              animation: "spin 12s linear infinite",
            }}
          />
        </AnimationStyle>
      </Stack>
    </Stack>
  );
}
